import { Navigate } from '@sorare/routing';

import {
  ANY_SPORT_ONBOARDING_SERIES_SELECT_TEAM_SLUG,
  NBA_ONBOARDING_CHOOSE_TEAM,
  NBA_ONBOARDING_CHOOSE_YOUR_LEVEL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

const OnboardingPage = () => {
  const {
    flags: {
      enableNbaQuickPlayOnboarding = false,
      enableSeriesOnboardingPacks = false,
    },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();

  if (enableSeriesOnboardingPacks) {
    return (
      <Navigate
        to={generateSportContextPath(
          ANY_SPORT_ONBOARDING_SERIES_SELECT_TEAM_SLUG,
          {
            params: { slug: 'nba' },
          }
        )}
        replace
      />
    );
  }

  if (enableNbaQuickPlayOnboarding) {
    return <Navigate to={NBA_ONBOARDING_CHOOSE_YOUR_LEVEL} replace />;
  }
  return <Navigate to={NBA_ONBOARDING_CHOOSE_TEAM} replace />;
};
export default OnboardingPage;
